import {Injectable} from '@angular/core';
import {BaseService} from '../core/service/base.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {PurchaseRequest} from '../model/purchase-request';
import {Observable} from 'rxjs';
import {HeaderConstants} from '../core/utils/headers.constants';
import {FileResource} from '../model/file';

@Injectable()
export class PurchaseRequestService extends BaseService<PurchaseRequest> {

  serviceUrl(): string {
    return `/api/t/{tenant}/purchase-requests`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  getAll(refresh = true): Observable<PurchaseRequest[]> {
    const paramsData = new HttpParams();
    const options = {params: paramsData, headers: new HttpHeaders().set(HeaderConstants.CACHED, refresh ? 'false' : 'true')};
    return this.http
      .get<PurchaseRequest[]>(`${this.serviceUrl()}/without-process`, options );
  }

  getDocument(id: number): Observable<Blob> {
    return this.http
      .get(`${this.serviceUrl()}/${id}/export-document`, {responseType: 'blob'});
  }
}
